"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useSiteConfigContext = void 0;
var _contexts = require("./../../config/contexts");
var _array = require("./../type-checks/array");
var _object = require("./../type-checks/object");
var _react = require("react");
require("../polyfills");

/**
 * Hook to retrieve site context object
 *
 * @name useSiteConfigContext
 * @returns {object} Site Configuration Object
 */
const useSiteConfigContext = () => {
  let context = (0, _react.useContext)(_contexts.SiteConfigContext);
  if (!(0, _object.isObject)(context)) {
    context = {};
  }
  if (!Object.hasOwn(context, "maintenance") || !(0, _array.isArray)(context.maintenance)) {
    context.maintenance = [];
  }
  return context;
};
exports.useSiteConfigContext = useSiteConfigContext;